import { getCsrfToken } from '../../../csrf';

type UploadResult = { success: true } | { success: false; errors: Record<string, string[]> };

export const uploadClientAgreement = async (pdf: File, name?: string): Promise<UploadResult> => {
  const formData = new FormData();
  formData.append('pdf', pdf);
  formData.append('document_type', 'executed_agreement');
  if (name) formData.append('name', name);

  const response = await fetch('/api/v1/firm/document_uploads', {
    method: 'POST',
    headers: {
      'X-CSRF-Token': getCsrfToken() || '',
      'X-REQUESTED-WITH': 'XMLHttpRequest',
    },
    credentials: 'same-origin',
    body: formData,
  });

  if (response.ok) {
    return { success: true };
  }

  if (response.status === 422) {
    const data = (await response.json()) as { errors: Record<string, string[]> };
    return { success: false, errors: data.errors };
  }

  return { success: false, errors: { base: ['An unexpected error occurred. Please try again.'] } };
};
